import { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { Button } from '@material-tailwind/react';
import { Link } from 'react-router-dom';

const PoomDataTable = () => {
  const [poomPostData, setPoomPostData] = useState([]);
  useEffect(() => {
    const collectionRef = collection(db, 'poomProducts');
    const q = query(collectionRef, orderBy('postedOn', 'desc'));

    const getPoomPostData = async () => {
      try {
        const data = await getDocs(q);
        setPoomPostData(
          data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        );
      } catch (error) {
        console.log(error);
      }
    };
    getPoomPostData();
  }, []);

  return (
    <div className="max-w-[1200px] mx-auto my-6 p-4">
      <h2 className="text-2xl font-bold py-2 text-center">Poom Pastry Posts:</h2>
      <div className="grid gap-2 lg:grid-cols-2">
        {poomPostData.map((data) => {
          return (
            <>
              <div className="w-full p-2 rounded-lg shadow-xl lg:flex lg:max-w-lg items-center">
                <img
                  className="object-cover w-full lg:w-40 lg:h-40"
                  src={data.poomPicture}
                  alt="food"
                />
                <div className="pl-2">
                  <h4 className="text-l font-bold tracking-tight">
                    {data.poomProductName}
                  </h4>
                  <p className="mt-2 text-sm leading-normal font-bold">
                    Location:{" "}
                    <span className="font-normal">{data.poomLocationName}</span>
                  </p>
                  <p className="text-sm leading-normal font-bold">
                    Posted At:{" "}
                    <span className="font-normal">
                      {data.postedOn.toDate().toDateString()}
                    </span>
                  </p>
                  <p className="text-sm leading-normal font-bold">
                    # of Requests:{" "}
                    <span className="font-normal">{data.numOfRequests}</span>
                  </p>
                  <p className="text-sm leading-normal font-bold">
                    Is Available: <span className='font-normal'>{String(data.isAvailable)}</span>
                  </p>
                  <Link
                    to={`/detail/${data.id}`}
                    state={{
                      uid: `${data.uid}`,
                      poomProductName: `${data.poomProductName}`,
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="sm"
                      color="orange"
                      className="mt-2"
                    >
                      Read More!
                    </Button>
                  </Link>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default PoomDataTable;
